import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CarrierRateFile } from 'src/app/_models/models';
import { CommonService } from '../common.service';

@Injectable({
  providedIn: 'root'
})
export class CarrierRateFilesService {

  constructor(private common: CommonService, private client: HttpClient) { }

  getAll<T>(label: string, carrierName: string, carrierId?: number): Observable<T>{

    return this.client.get<T>(this.common.getApiAddress() + "/CarrierRateFiles?label=" + label + "&carrierName=" + carrierName + "&carrierid=" + carrierId)
      .pipe(
        map<T, T>(
          r => {
            return r;
          }
        ),
        catchError(
          e => {
            return this.common.handleError("Carrier invoice file get failed", e);
          }
        )
      );
  }

  get<T>(id: number, action: string, servicecode?: string): Observable<T> {

    let url;

    if (servicecode == undefined || servicecode == null) {
      url = this.common.getApiAddress() +
        "/CarrierRateFiles/" + id.toString() + "?action=" + action;
    } else {
      url = this.common.getApiAddress() +
        "/CarrierRateFiles/" + id.toString() + "?action=" + action + "&servicecode=" + servicecode;
    }

    return this.client.get<T>(url)
      .pipe(
        map<T, T>(
          r => {
            return r;
          }
        ),
        catchError(
          e => {
            return this.common.handleError("Carrier invoice file get failed", e);
          }
        )
      );
  }

  delete(id: number): Observable<CarrierRateFile> {
    return this.client.delete<CarrierRateFile>(this.common.getApiAddress() + "/CarrierRateFiles/" + id.toString())
      .pipe(
      map<CarrierRateFile, CarrierRateFile>(r => {
          return r;
        }),
        catchError(e => {
          return this.common.handleError("Failed to delete rate file", e);
        })
      );
  }

  update(data: CarrierRateFile): Observable<CarrierRateFile> {
    return this.client.put<CarrierRateFile>(this.common.getApiAddress() + "/CarrierRateFiles/" + data.id, data)
      .pipe(
        map<CarrierRateFile, CarrierRateFile>(r => {
          return r;
        }),
        catchError(e => {
          return this.common.handleError("Edit rating profile failed", e);
        })
      );
  }



  getRateFiles(carrierId?: string): Observable<any[]> {
    let url = this.common.getApiAddress();


    url = url + "/CarrierRateFiles/GetAll?carriername=" + carrierId;


    return this.client.get<any[]>(url)
      .pipe(
        map<any[], any[]>(r => {
          return r;
        }),
        catchError(e => {
          return this.common.handleError("Carriers get failed", e);
        })
      );
  }

  mapClientRateFile(object: any): Observable<any> {
    return this.client.post<any>(this.common.getApiAddress() + "/clients/MapCarrierRateFilesForClient", object)
      .pipe(
        map<any[], any[]>(r => {
          return r;
        }),
        catchError(e => {
          return this.common.handleError("Carriers get failed", e);
        })
      );
  }

  updateMappedClientRateFile(object: any): Observable<any> {
    return this.client.post<any>(this.common.getApiAddress() + "/clients/UpdateMapCarrierRateFilesForClient", object)
      .pipe(
        map<any[], any[]>(r => {
          return r;
        }),
        catchError(e => {
          return this.common.handleError("Carriers get failed", e);
        })
      );
  }

  getMappedClientRateFiles(clientId: number): Observable<[]> {
    return this.client.get<any>(this.common.getApiAddress() + "/clients/GetMappedCarrierRateFilesForClient?id=" + clientId)
      .pipe(
        map<[], []>(r => {
          return r;
        }),
        catchError(e => {
          return this.common.handleError("Carriers get failed", e);
        })
      );
  }

  deleteMappedClientRateFile(clientId?: number, carrierRateFileId?: number): Observable<any[]> {

    let url = this.common.getApiAddress();


    url = url + "/clients/DeleteMapCarrierRateFilesForClient?clientId=" + clientId + "&carrierRateFileId=" + carrierRateFileId;


    return this.client.delete<any[]>(url)
      .pipe(
        map<any[], any[]>(r => {
          return r;
        }),
        catchError(e => {
          return this.common.handleError("Carriers get failed", e);
        })
      );
  }



}
